import React from "react";
import Navbar from "../components/Navbar";
import { BsTwitterX } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import logo from "../assets/image 107.svg";
import { Link } from "react-router";

const Terms = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="d-flex flex-column" style={{ backgroundColor: "#f7ebee" }}>
      <Navbar />
      <div className="privacy-top-margin container d-flex flex-column">
        <div className="d-flex flex-column">
          <span
            style={{
              fontSize: "48px",
              lineHeight: "62px",
              fontWeight: 400,
              color: "#CC2B52",
            }}
          >
            Terms of use
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            Welcome to PatchUp. These Terms of Use ("Terms") govern your use of
            the services provided by PatchUp ("we," "us," or "our") through our
            website and application ("Platform"). By accessing or using our
            Platform, you agree to these Terms in full. If you do not agree,
            please refrain from using our Platform or services.
          </span>
        </div>

        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            1. Acceptance of Terms{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            By accessing and using our services, you confirm that:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>You are at least 18 years old.</li>
              <li>You agree to these Terms and our Privacy Policy.</li>
              <li>
                If you do not accept these Terms, you must stop using our
                services immediately.
              </li>
            </ul>
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            2. Use of Cookies{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp uses cookies to improve user experience. By using our
            Platform, you consent to our use of cookies as outlined in our
            Privacy Policy.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            3. Account Setup and Security{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            To use our services, you must create an account with accurate
            details. You are responsible for:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>Keeping your login credentials confidential.</li>
              <li>All activities under your account.</li>
              <li>Informing us immediately if your account is compromised.</li>
            </ul>
            PatchUp is not liable for any unauthorized use of your account.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            4. Services Offered{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp provides relationship counseling, compatibility analysis,
            and related services. We enable users to connect with professionals
            like psychologists, counselors, and coaches through the Platform.
            Please note:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>
                We are not a healthcare provider and do not offer medical
                services.
              </li>
              <li>
                Information shared with us may be shared with experts to provide
                services.
              </li>
            </ul>
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            5. Payment, Cancellation, and Refunds{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>All consultations or services are subject to payment.</li>
              <li>
                Cancellations or rescheduling must be made at least 24 hours
                before the appointment.
              </li>
              <li>
                Refunds will be governed by the specific terms of the service
                booked.
              </li>
            </ul>
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            6. Acceptable Use{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            You agree not to:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>Use the Platform for unlawful activities.</li>
              <li>
                Copy, modify, or distribute content from the Platform without
                authorization.
              </li>
              <li>
                Use the Platform to spread harmful content like viruses or
                malware.
              </li>
            </ul>
            We reserve the right to suspend or terminate accounts violating
            these terms.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            7. Intellectual Property{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            All content on the Platform, including text, images, software, and
            designs, is owned by PatchUp or its licensors. You may not
            reproduce, modify, or distribute this content without permission.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            8. Disclaimer of Warranties{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            Our services are provided "as is" without warranties of any kind. We
            do not guarantee uninterrupted service or the accuracy of content.
            Use of our Platform is at your own risk.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            9. Limitation of Liability{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp will not be held responsible for:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>Any indirect or consequential losses.</li>
              <li>Loss of data or profits.</li>
            </ul>
            Our liability is limited to INR 1000 or the amount paid for the
            service, whichever is lesser.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            10. Indemnity{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            You agree to indemnify and hold PatchUp harmless from any claims,
            damages, or expenses arising out of your use of the Platform or
            breach of these Terms.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            11. Dispute Resolution{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            Any disputes will be resolved through arbitration by a sole
            arbitrator appointed by PatchUp. The venue for arbitration will be
            Bangalore, and the decision will be binding. Courts in Bangalore
            will have exclusive jurisdiction.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            12. Changes to Terms{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp reserves the right to update these Terms at any time.
            Continued use of the Platform after changes are made implies your
            acceptance of the revised Terms.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            13. Termination{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            You can terminate your account at any time by contacting us at
            support@patchup.com. We may also suspend or terminate your account
            if you violate these Terms.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            14. Contact Us{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            If you have any questions, please reach out to us at
            support@patchup.com.
          </span>
        </div>
      </div>
      <div className="mt-5 pt-5 container pb-3">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <img src={logo}></img>
          </div>
          <div className="d-flex gap-3">
            <BsTwitterX style={{ color: "#CC2B52" }} />
            <BsLinkedin style={{ color: "#CC2B52" }} />
            <BsInstagram style={{ color: "#CC2B52" }} />
          </div>
        </div>
        <hr></hr>
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-3">
            <span
              style={{
                color: "#3B486E99",
                fontSize: "16px",
                fontWeight: "400",
                fontFamily: "DM Sans",
              }}
            >
              © Patchup 2025
            </span>
            <Link to={"/privacy-policy"} style={{ textDecoration: "none" }}>
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                  fontFamily: "DM Sans",
                }}
              >
                Privacy Policy
              </span>
            </Link>
            <Link
              to={"/terms-and-conditions"}
              style={{ textDecoration: "none" }}
            >
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                  fontFamily: "DM Sans",
                }}
                onClick={scrollToTop}
              >
                Terms of use
              </span>
            </Link>
          </div>
          <div>
            {" "}
            <span
              style={{
                color: "#3B486E",
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "DM Sans",
              }}
            >
              Support@patchup.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
